import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import { log } from "../../../common/utils/Logging";
export var withLogging = function withLogging(WrappedComponent, className) {
  return /*#__PURE__*/function (_Component) {
    _inherits(Logging, _Component);

    var _super = _createSuper(Logging);

    function Logging() {
      _classCallCheck(this, Logging);

      return _super.apply(this, arguments);
    }

    _createClass(Logging, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
          logger: log.getLogger(className)
        }, this.props));
      }
    }]);

    return Logging;
  }(Component);
};